
import AdvCarousel from "./AdvCarousel.jsx";
import Slider from "./Slider.jsx";

export default function ExampleHomePage({data, theme}) {
  return (
    <div className='exampleHomePage' style={{backgroundColor:`${theme.secondary_color}`}}>
      <h3 className="exampleHomePage_header" style={{textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>ברוכים הבאים ל - {data.website_name}!</h3>
      <h4 className="exampleHomePage_subHeader" style={{ width:"90%", margin:"auto", textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>{data.details}</h4>
      <AdvCarousel data={data} theme={theme}/>
      <h3 className="exampleHomePage_header" style={{ width:"80%", margin:"auto", textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`, borderBottom:`0.5px solid ${theme.accent_color}`}}>מה חדש אצלנו?</h3>
      <Slider products={data?.products} header={"המבצעים שלנו"} theme={theme} filterParam={"sale"}/>
      <Slider products={data?.products} header={"החדשים שלנו"} theme={theme} filterParam={"new"}/>
    </div>
  )
}
